<div class="min-h-screen flex items-center justify-center bg-gradient-to-br from-dark to-primary px-4">
  <div class="w-full max-w-md bg-white rounded-lg shadow-lg p-8">
    <div class="text-center mb-8">
      <img src="assets/icon/codijobs.png" alt="Codijobs" class="mx-auto w-20 h-20 mb-4" />
      <h2 class="text-2xl font-bold text-gray-800">Administrador</h2>
    </div>
    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-6">
      <app-input-text label="Correo electrónico" placeholder="correo@ejemplo.com" [control]="loginForm.get('email')">
      </app-input-text>
      <div class="my-2"></div>
      <app-input-text label="Contraseña" placeholder="Tu contraseña" type="password"
        [control]="loginForm.get('password')">
      </app-input-text>
      <div class="pt-4">
        <app-loading-button [text]="'Iniciar sesión'" [loading]="loading" type="submit">
        </app-loading-button>
      </div>
    </form>
  </div>
</div>
